/**
 * @generated SignedSource<<be316411a13de600d23b0c092a8488a7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Main_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Channels_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Graphiql_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Home_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Profile_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Subscribe_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FinishSetup_viewer"
    }
  ],
  "type": "User",
  "abstractKey": null
};

node.hash = "3791fa724d1c2169ff0a83f56182ebbd";

export default node;
